import { Component, OnInit, Input } from '@angular/core';
import { OrganizationMaster } from '../../../Models/organization-master'
import { EmmService } from '../../../Service/emm.service'
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { DatePipe } from '@angular/common';
import { ApiService } from 'src/app/Service/api.service';
import { NgForm } from '@angular/forms';
import { trimTrailingNulls } from '@angular/compiler/src/render3/view/util';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.css'],
  providers: [DatePipe]
})

export class OrganizationComponent implements OnInit {

  @Input() drawerClose: Function;
  @Input() data: OrganizationMaster;
  @Input() drawerVisible: boolean;

  listdata1 = [];
  listdata2 = [];
  orgId = this.cookie.get('orgId');
  loadingRecords = true;
  isSpinning = false;
  fileData: File = null;
  isOk = true;
  emailpattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  namepatt = /^[a-zA-Z \-\']+/
  mobpattern = /^[6-9]\d{9}$/

  onlynum = /^[0-9]*$/
  onlychar = /^[a-zA-Z ]*$/
  longitudepattern = /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$/
  latitudepattern = /^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$/
  pat1 = /^\d{6}$/;
  namepattern = /[a-zA-Z][a-zA-Z ]+/
  cityRegex = /^[a-zA-z] ?([a-zA-z]|[a-zA-z] )*[a-zA-z]$/;
  aaddpattern = /^[a-zA-Z0-9\s,'-]*$/
  namepatte = /[ .a-zA-Z]+/
  passpattern = /^\S*$/
  // passpattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d[\]{};:=<>_+^#$@!%*?&]{8,30}$/
  imgUrl
  time
  time1
  time2
  date
  //dateFormat="dd/MMM/yyyy"
  constructor(private api: ApiService, private cookie: CookieService, private datePipe: DatePipe, private message: NzNotificationService) {
  }

  //imgUrl="http://192.168.0.10:8000/static/organization/";


  ngOnInit() {
    this.getallorg1();
  }

  omit(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  close(accountMasterPage: NgForm) {
    this.drawerClose();
    this.resetDrawer(accountMasterPage);
  }

  resetDrawer(accountMasterPage: NgForm) {
    accountMasterPage.form.reset();
    this.add();
    // this.getAccounts();
    // this.getAccountGroups();
    // this.getAccountTypes();
  }

  add(): void {
    // this.api.getAllDesignation(1,1,'STATUS','desc', ' AND  ORG_ID ='+ this.orgId).subscribe (data =>{
    //   if (data['count']==0){
    //     this.data.STATUS=true;
    //   }else
    //   {
    //     this.data.STATUS=true;
    //   }
    // },err=>{
    //   console.log(err);
    // })
  }

  emailExist = false;

  getallorg1() {
    this.api.getAllOrganizations(0, 0, 'ID', 'desc', "").subscribe(data => {
      if (data['code'] == 200) {
        this.listdata1 = data['data'];
        console.log(this.listdata1)
      }
    }, err => {
      console.log(err);
    });
  }

  getallorg2(id) {
    this.api.getAllOrganizations(0, 0, 'ID', 'desc', " and ID !=" + id).subscribe(data => {
      if (data['code'] == 200) {
        this.listdata2 = data['data'];
        console.log(this.listdata2)
      }
    }, err => {
      console.log(err);
    });
  }

  save(addNew: boolean, accountMasterPage: NgForm): void {
    this.isOk = true;

    if (this.data.NAME == undefined || this.data.NAME.trim() == '') {
      this.isOk = false;
      this.message.error("Please Enter Name", '')
    }

    if (!this.namepatte.test(this.data.NAME.toString())) {
      this.isOk = false;
      this.message.error("Please Enter Valid Name", '')
    }

    if (this.data.ADMIN_NAME == undefined || this.data.ADMIN_NAME.trim() == '') {
      this.isOk = false;
      this.message.error("Please Enter Admin Name", '')
    }

    if (!this.namepatte.test(this.data.ADMIN_NAME.toString())) {
      this.isOk = false;
      this.message.error("Please Enter Valid Admin Name", '')
    }

    if (this.data.MOBILE_NUMBER == null || this.data.MOBILE_NUMBER == undefined) {
      this.isOk = false;
      this.message.error("Please Enter Mobile Number", '')
    }

    if (!this.mobpattern.test(this.data.MOBILE_NUMBER.toString())) {
      this.isOk = false;
      this.message.error("Please Enter Valid Mobile Number", '')
    }

    if (this.data.EMAIL_ID == null || this.data.EMAIL_ID == undefined) {
      this.isOk = false;
      this.message.error("Please Enter Email-Id", '')
    }

    if (!this.emailpattern.test(this.data.EMAIL_ID)) {
      this.isOk = false;
      this.message.error("Please Enter Valid Email-Id", '')
    }

    if (this.data.PASSWORD != undefined) {
      if (this.data.PASSWORD.trim() != "") {
        if (this.data.PASSWORD.length >= 8) {
          if (!this.api.passwordIsValid(this.data.PASSWORD)) {
            this.isOk = false;
            this.message.error("Please Enter Valid Password", "");
          }

        } else {
          this.isOk = false;
          this.message.error("Password Must be or Greater than 8 Characters", "");
        }

      } else {
        this.isOk = false;
        this.message.error("Please Enter Password", "");
      }

    } else {
      this.isOk = false;
      this.message.error("Please Enter Password", "");
    }

    if (this.data.ADDRESS_LINE_1 == undefined || this.data.ADDRESS_LINE_1.trim() == '') {
      this.isOk = false;
      this.message.error("Please Enter Address 1 ", '')
    }

    if (!this.namepatte.test(this.data.ADDRESS_LINE_1)) {
      this.isOk = false;
      this.message.error("Please Enter Valid Address", '')
    }

    if (this.data.ADDRESS_LINE_2 == undefined || this.data.ADDRESS_LINE_2.trim() == '') {
      this.isOk = false;
      this.message.error("Please Enter Address 2", '')
    }

    if (!this.namepatte.test(this.data.ADDRESS_LINE_2)) {
      this.isOk = false;
      this.message.error("Please Enter Valid Address", '')
    }

    if (this.data.CITY == null || this.data.CITY.trim() == '') {
      this.isOk = false;
      this.message.error("Please Enter City", '')
    }

    if (!this.onlychar.test(this.data.CITY.toString())) {
      this.isOk = false;
      this.message.error("Please Enter Valid City Name", '')
    }

    if (this.data.TEHSIL == null || this.data.TEHSIL.trim() == '') {
      this.isOk = false;
      this.message.error("Please Enter Tehsil ", '')
    }

    if (!this.onlychar.test(this.data.TEHSIL.toString())) {
      this.isOk = false;
      this.message.error("Please Enter Valid Tehsil Name", '')
    }

    if (this.data.DISTRICT == null || this.data.DISTRICT.trim() == '') {
      this.isOk = false;
      this.message.error("Please Enter District", '')
    }

    if (!this.onlychar.test(this.data.DISTRICT.toString())) {
      this.isOk = false;
      this.message.error("Please Enter Valid District Name", '')
    }

    if (this.data.STATE == null || this.data.STATE.trim() == '') {
      this.isOk = false;
      this.message.error("Please Enter State ", '')
    }

    if (!this.onlychar.test(this.data.STATE.toString())) {
      this.isOk = false;
      this.message.error("Please Enter Valid State Name", '')
    }

    if (this.data.COUNTRY == null || this.data.COUNTRY.trim() == '') {
      this.isOk = false;
      this.message.error("Please Enter Country", '')
    }

    if (!this.onlychar.test(this.data.COUNTRY.toString())) {
      this.isOk = false;
      this.message.error("Please Enter Valid Country Name", '')
    }

    if (this.data.PINCODE == null || this.data.PINCODE == undefined) {
      this.isOk = false;
      this.message.error("Please Enter Pincode ", '')
    }

    if (!this.pat1.test(this.data.PINCODE.toString())) {
      this.isOk = false;
      this.message.error("Please Enter Valid Pincode", '')
    }

    if (this.data.LONGITUTE == null || this.data.LONGITUTE == undefined) {
      this.isOk = false;
      this.message.error("Please Enter Longitude", '')
    }

    if (!this.longitudepattern.test(this.data.LONGITUTE.toString())) {
      this.isOk = false;
      this.message.error("Please Enter Valid Longitude", '')
    }

    if (this.data.LATITUTE == null || this.data.LATITUTE == undefined) {
      this.isOk = false;
      this.message.error("Please Enter Latitude ", '')
    }

    if (!this.latitudepattern.test(this.data.LATITUTE.toString())) {
      this.isOk = false;
      this.message.error("Please Enter Valid Latitude", '')
    }

    if (this.isOk) {
      this.isSpinning = true;
      this.data.USER_ID = this.api.userId;
      this.data.ROLE_ID = this.api.roleId;
      this.orgId = this.cookie.get('orgId')

      if (this.data.ID) {
        var emailData2 = this.listdata2.filter(obj => {
          return obj.EMAIL_ID == this.data.EMAIL_ID;
        });

        if (emailData2.length == 0) {
          this.api.updateOrganization(this.data).subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("Oraganization Updated Successfully", "");

              if (!addNew)
                this.drawerClose();

              this.isSpinning = false;
              this.resetDrawer(accountMasterPage);

            } else {
              this.message.error("Oraganization Updation Failed", "");
              this.resetDrawer(accountMasterPage);
              this.isSpinning = false;
            }
          });

        } else {
          this.message.error("E-Mail Exist Please Enter Other E-Mail", "");
          this.isSpinning = false;
        }

      } else {
        var emailData = this.listdata1.filter(obj => {
          return obj.EMAIL_ID == this.data.EMAIL_ID;
        });

        console.log(this.data);

        if (emailData.length == 0) {
          this.api.createOrganization(this.data).subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.isSpinning = false;

              this.message.success("Oraganization Created Successfully...", "");
              if (!addNew) {
                this.drawerClose();
                this.resetDrawer(accountMasterPage);

              } else {
                this.data = new OrganizationMaster();
                this.resetDrawer(accountMasterPage);
              }

            } else {
              this.message.error("Oraganization Creation Failed...", "");
              this.isSpinning = false;
            }
          });

        } else {
          this.message.error("E-Mail Exist Please Enter Other E-Mail...", "");
          this.isSpinning = false;
        }
      }

    } else {
      // this.message.error("Please Fill All Required Fields...", "");
      this.isSpinning = false;
    }
  }

  onFileSelected(event) {
    this.imgUrl = event.target.value
    this.fileData = <File>event.target.files[0];
    console.log(this.fileData)
    var fileExt = this.fileData.name.split('.').pop();
    console.log("extesion: " + fileExt)
  }
}
